import { areaNav } from "./components/areaNav";
import { flickity } from "./components/flickity";
import { nav } from "./components/nav";
import { ticker } from "./components/ticker";
import { validations } from "./components/validations";

areaNav();
flickity();
nav();
ticker();
validations();
